import React from "react";
import {Col, Container, Row} from "reactstrap";

const Footer = () => (
    <footer className={"test-footer text-white small"}>
        <Container fluid>
            <Row>
                <Col md={{size:2, order: 1}} xs={{size:6, order: 2}}>
                    <a href={"https://www.muzdrakova.com/"} title={"Към muzdrakova.com"}>www.muzdrakova.com</a>
                </Col>
                <Col md={{size:8, order: 2}} xs={{size:12, order: 1}} className={"text-center"}>Споделете теста за депресия
                    <div className="fb-share-button ml-1" data-href="https://www.muzdrakova.com/test-za-depresia/#/" data-layout="button_count" data-size="small">
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.muzdrakova.com%2Ftest-za-depresia%2F%23%2F&amp;src=sdkpreparse"
                           className="fb-xfbml-parse-ignore">Share</a></div>
                </Col>
                <Col md={{size:2, order: 3}} xs={{size:6, order: 3}} className={"text-right"}>
                    <a href={"https://www.playline.studio/"} title={"Web design playline.studio"}>playline.studio</a>
                </Col>
            </Row>
        </Container>
    </footer>
);

export default Footer